import {GenericChecker} from "../../subjective/GenericChecker";
import * as ArrayUtils from "../../../../../utils/ArrayUtil";

export class ClinicalImpressionChecker extends GenericChecker {
    static isDataEntered(entity) {
        return !ArrayUtils.isEmpty(entity);
    }
}